var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entry-layout"},[_c('progress-bar'),_vm._v(" "),(_vm.getUserLoaded)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }